export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  image: string;
  imageAlt: string;
  date: string;
  heat: string;
  tags: string[];
  isHot: boolean;
  isExclusive: boolean;
  author: string;
  authorTitle: string;
}

export const articles: Article[] = [
  {
    id: '1',
    slug: 'wanghong-fancha-baoliao-001',
    title: '某千万粉丝网红私下反差视频流出，豪宅聚会画面曝光',
    excerpt: '近日有知情人士向911爆料网提供了一段某千万粉丝网红在私人豪宅聚会的不雅视频，画面中该网红与荧幕前阳光形象形成巨大反差，引发粉丝热议。',
    content: `<p>近日，有圈内知情人士向911爆料网独家提供了一段猛料视频。视频拍摄于某知名网红位于上海的私人豪宅内，时间为今年3月的某个深夜聚会。</p>
    <p>据爆料人透露，该网红在公众面前一直维持着阳光、正能量的形象，粉丝数量超过1500万，是平台重点扶持的头部创作者。然而，私下里的作风却与荧幕前判若两人。</p>
    <p>视频中可以看到，聚会现场气氛热烈，参与人员包括多名平台主播和娱乐圈边缘人物。该网红在酒精作用下言行出格，与平时精心营造的人设形成强烈反差。</p>
    <p>目前该网红团队尚未对此事作出公开回应。但其社交账号评论区已被粉丝"攻陷"，大量粉丝表达了失望和质疑。有粉丝留言："没想到你是这样的人，太让人失望了。"</p>
    <p>业内人士分析认为，此类事件在网红圈并非个例。很多网红为了流量和商业价值，刻意塑造完美人设，但私下生活与公众形象存在巨大差距。一旦被曝光，将面临严重的信任危机和商业损失。</p>
    <p>911爆料网将持续关注此事的后续发展，为各位吃瓜群众带来第一手猛料。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20luxury%20mansion%20party%20scene%20at%20night%2C%20silhouette%20of%20people%20behind%20frosted%20glass%2C%20dramatic%20lighting%20with%20red%20and%20black%20tones%2C%20cinematic%20composition%2C%20abstract%20decadent%20atmosphere%2C%20warm%20interior%20lights%20contrasting%20with%20dark%20shadows%2C%20mysterious%20and%20provocative%20mood%2C%20editorial%20photography%20style%20with%20grainy%20texture%2C%20high%20contrast%2C%20no%20visible%20faces%2C%20clean%20dark%20background&width=800&height=600&seq=article-wanghong-001&orientation=landscape',
    imageAlt: '网红私下豪宅聚会画面',
    date: '2026-07-06',
    heat: '128.5w',
    tags: ['网红', '反差', '豪宅', '聚会'],
    isHot: true,
    isExclusive: true,
    author: '匿名爆料者A',
    authorTitle: '圈内知情人士',
  },
  {
    id: '2',
    slug: 'mingxing-liaotian-jilu-xielou-002',
    title: '某顶流男星暧昧聊天记录遭泄露，对方竟是已婚女演员',
    excerpt: '一组疑似某顶流男星的微信聊天截图在网络上疯传，对话内容暧昧露骨，而聊天对象被扒出是圈内一位已婚女演员，引发轩然大波。',
    content: `<p>昨晚深夜，一组疑似某当红顶流男星的微信聊天记录截图在各大社交平台疯传。截图中对话内容极其暧昧露骨，涉及大量私密话题。</p>
    <p>更令人震惊的是，经过网友深度扒皮，聊天对象的身份被锁定为圈内一位已婚女演员。该女演员与丈夫在公众面前一直以恩爱夫妻形象示人，此次事件无疑给其婚姻带来了巨大冲击。</p>
    <p>从泄露的聊天记录来看，两人的暧昧关系已持续数月之久。对话中不仅包含日常嘘寒问暖，更有大量超越普通朋友界限的亲密内容。其中一段对话显示，两人曾多次在对方外出工作时私下见面。</p>
    <p>截至目前，涉事双方均未对此事作出任何回应。两人的工作室电话也处于无人接听状态。</p>
    <p>法律界人士表示，私自泄露他人聊天记录涉嫌侵犯隐私权，传播者也可能承担相应法律责任。但此类事件在娱乐圈屡禁不止，背后往往涉及复杂的利益纠葛。</p>
    <p>911爆料网提醒各位吃瓜群众，理性吃瓜，不传谣不信谣。我们将持续关注此事进展。</p>`,
    category: '明星聊天记录',
    categorySlug: 'mingxing-liaotian',
    image: 'https://readdy.ai/api/search-image?query=Blurred%20phone%20screen%20showing%20WeChat%20conversation%20interface%20in%20Chinese%2C%20dark%20ambient%20lighting%2C%20phone%20on%20a%20dark%20wooden%20desk%2C%20cinematic%20noir%20style%2C%20dramatic%20shadows%2C%20mysterious%20atmosphere%2C%20red%20accent%20light%2C%20privacy%20leak%20concept%2C%20high%20contrast%2C%20grainy%20vintage%20texture%2C%20simple%20dark%20background&width=800&height=600&seq=article-chat-002&orientation=landscape',
    imageAlt: '明星聊天记录泄露截图',
    date: '2026-07-05',
    heat: '256.3w',
    tags: ['明星', '聊天记录', '出轨', '已婚'],
    isHot: true,
    isExclusive: false,
    author: '八卦小王子',
    authorTitle: '娱乐记者',
  },
  {
    id: '3',
    slug: 'bozhu-baoliao-jingji-gongsi-003',
    title: '曝某MCN机构强迫旗下博主陪酒应酬，不听话就雪藏封杀',
    excerpt: '一位曾签约知名MCN机构的前博主向911爆料网独家爆料，该机构长期强迫旗下签约博主参加商务酒局应酬，拒绝者均遭到不同程度的打压和雪藏。',
    content: `<p>近日，一位不愿透露姓名的前签约博主联系到911爆料网，揭露了某头部MCN机构内部的黑暗操作。据该博主描述，机构长期以"商务合作"为名，强迫旗下签约博主参加各类酒局应酬。</p>
    <p>"每次说有品牌方想见面谈合作，到了才发现就是喝酒。你不喝就是不给面子，下次好的商务资源就不会给你。"该博主向记者透露，这种情况从签约第二个月就开始了，几乎每周都有。</p>
    <p>更令人愤怒的是，对于那些明确拒绝参加此类应酬的博主，机构会采取软性封杀的手段。包括但不限于：减少推荐流量、不分配优质商务资源、在内部群中冷嘲热讽、合同到期后以各种理由拒绝续约等。</p>
    <p>该博主表示，自己就是因为多次拒绝陪酒要求，最终被机构以"发展方向不一致"为由提前解约，并且被要求支付高额违约金。</p>
    <p>此事在网红圈内引发广泛讨论。多位博主匿名表示，此类现象在行业内非常普遍。"你不去，有的是人去。很多小博主为了资源什么都愿意做。"</p>
    <p>目前，涉事MCN机构尚未对此事作出回应。911爆料网将持续关注事件进展。</p>`,
    category: '博主私下爆料',
    categorySlug: 'bozhu-baoliao',
    image: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20interior%20at%20night%2C%20empty%20conference%20room%20with%20wine%20glasses%20on%20table%2C%20dim%20ambient%20lighting%20with%20red%20neon%20accent%2C%20mysterious%20and%20oppressive%20mood%2C%20cinematic%20noir%20photography%2C%20light%20shafts%20through%20blinds%2C%20dramatic%20shadows%2C%20clean%20background%2C%20suspense%20atmosphere&width=800&height=600&seq=article-mcn-003&orientation=landscape',
    imageAlt: 'MCN机构内部黑暗操作',
    date: '2026-07-04',
    heat: '89.7w',
    tags: ['MCN', '潜规则', '陪酒', '封杀'],
    isHot: true,
    isExclusive: true,
    author: '暗夜追踪者',
    authorTitle: '调查记者',
  },
  {
    id: '4',
    slug: 'nvtuanti-neidou-zhenxiang-004',
    title: '某当红女团内部不和实锤，成员深夜互撕聊天记录外泄',
    excerpt: '某当红女子组合内部矛盾终于浮出水面，一段成员间深夜争吵的群聊记录被曝光，内容火药味十足，彻底打破了此前姐妹情深的假象。',
    content: `<p>在荧幕前一直以"姐妹情深"形象示人的某当红女子组合，近日被爆出内部矛盾严重。一段据称是该组合成员群聊的截图在网络上流出，内容令人震惊。</p>
    <p>聊天记录显示，几位成员因为资源分配不均、站位排序等问题爆发了激烈争吵。其中一位成员直言："每次都是你站在C位，我们就是背景板是吧？"另一位则回怼："有本事你也让公司给你资源啊。"</p>
    <p>对话中甚至涉及人身攻击，用词之激烈完全不像是"姐妹"。事实上，关于该组合内部不和的传闻由来已久。此前就有粉丝从成员们在公开场合的微表情和互动细节中看出了端倪。</p>
    <p>业内人士分析，偶像团体内部竞争激烈，资源分配不均是常态。加上长期高强度的工作和几乎没有私人空间的生活，矛盾积累到一定程度爆发并不奇怪。</p>
    <p>目前该组合的经纪公司发布声明称"聊天记录系伪造"，并表示将追究造谣者的法律责任。但网友们并不买账，纷纷表示"越描越黑"。</p>`,
    category: '明星聊天记录',
    categorySlug: 'mingxing-liaotian',
    image: 'https://readdy.ai/api/search-image?query=Dark%20backstage%20area%20of%20a%20concert%20hall%2C%20silhouettes%20of%20multiple%20female%20figures%20standing%20apart%20from%20each%20other%2C%20dramatic%20split%20lighting%2C%20tension%20and%20conflict%20mood%2C%20cinematic%20composition%2C%20red%20and%20blue%20contrast%20lighting%2C%20mysterious%20atmosphere%2C%20clean%20dark%20background%2C%20editorial%20photography&width=800&height=600&seq=article-girlgroup-004&orientation=landscape',
    imageAlt: '女团成员内部不和',
    date: '2026-07-03',
    heat: '198.2w',
    tags: ['女团', '不和', '聊天记录', '内斗'],
    isHot: false,
    isExclusive: false,
    author: '娱乐圈显微镜',
    authorTitle: '娱乐博主',
  },
  {
    id: '5',
    slug: 'zhibo-jian-jiahuo-neimu-005',
    title: '某头部带货主播直播间数据造假，真实销量不足公布的十分之一',
    excerpt: '知情人士向911爆料网透露，某拥有2000万粉丝的头部带货主播，直播间动辄数亿的GMV实为注水数据，真实成交额仅有公布的十分之一左右。',
    content: `<p>直播带货行业的虚假繁荣正在被一层层揭开。近日，一位曾在某头部带货主播团队工作过的前员工向911爆料网爆料，该主播直播间的销售数据存在严重造假。</p>
    <p>据该前员工透露，直播间常用的造假手段包括：组织水军大量下单然后在直播结束后退款、与品牌方协商虚假刷单、使用多个账号循环下单制造虚假热度等。</p>
    <p>"每次直播前我们都会准备一批'自己人'账号，专门用来在直播中下单冲销量。这些订单在直播结束后24小时内会全部退掉。"该前员工详细描述了造假流程。</p>
    <p>更令人震惊的是，甚至连直播间显示的在线观看人数也是通过技术手段注水的。"真实在线人数大概只有显示数字的三分之一。"</p>
    <p>行业数据显示，直播带货行业的平均退货率在30%-50%之间，部分品类甚至高达70%。但很多主播对外宣传时只提单量不提退货，制造出销量火爆的假象。</p>
    <p>该主播团队目前尚未对此作出回应。但此事已在行业内引起广泛关注，多位从业者呼吁建立更透明的直播数据监管机制。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    image: 'https://readdy.ai/api/search-image?query=Dark%20live%20streaming%20studio%20setup%20with%20bright%20ring%20light%20and%20empty%20product%20display%2C%20dramatic%20contrast%20between%20bright%20foreground%20and%20dark%20background%2C%20mysterious%20mood%2C%20cinematic%20lighting%2C%20fake%20numbers%20on%20screen%2C%20deception%20theme%2C%20red%20accent%20glow%2C%20clean%20composition&width=800&height=600&seq=article-livestream-005&orientation=landscape',
    imageAlt: '直播间数据造假',
    date: '2026-07-02',
    heat: '167.8w',
    tags: ['直播带货', '数据造假', 'GMV', '退货'],
    isHot: false,
    isExclusive: true,
    author: '数据猎人',
    authorTitle: '财经调查记者',
  },
  {
    id: '6',
    slug: 'yingshi-quan-qian-guize-006',
    title: '娱乐圈选角潜规则大起底：想上戏先上船，多位女星曾遭暗示',
    excerpt: '911爆料网收到多位圈内人士投稿，揭露影视圈选角过程中的潜规则乱象。多位年轻女演员表示曾遭遇"想上戏先上船"的暗示例行。',
    content: `<p>影视圈的"潜规则"一直是一个讳莫如深却又人尽皆知的话题。近日，911爆料网采访了多位圈内人士，试图揭开这一灰色地带的面纱。</p>
    <p>一位曾参演多部网剧的年轻女演员匿名透露，自己在试镜过程中曾多次遭遇导演或制片人的暗示。"他们会说'晚上来酒店聊聊剧本'，或者直接说'想上这部戏就得会做人'。"</p>
    <p>另一位已经退圈的演员表示，这种现象在行业里已经成了一种"公开的秘密"。"你不愿意，有的是人愿意。好的角色就那么几个，竞争太激烈了。"</p>
    <p>更令人担忧的是，一些不法分子甚至利用年轻演员想红的心态，以"选角导演"的名义进行诈骗。他们以试镜为由约见年轻女性，实则图谋不轨。</p>
    <p>业内人士呼吁，行业需要建立更透明、规范的选角机制，从根本上杜绝此类乱象。同时也提醒怀揣演艺梦想的年轻人，提高警惕，保护好自己。</p>`,
    category: '博主私下爆料',
    categorySlug: 'bozhu-baoliao',
    image: 'https://readdy.ai/api/search-image?query=Dark%20audition%20room%20with%20single%20spotlight%20on%20empty%20stage%2C%20dramatic%20theater%20lighting%2C%20mysterious%20and%20tense%20atmosphere%2C%20red%20velvet%20curtain%20in%20background%2C%20cinematic%20noir%20style%2C%20deep%20shadows%2C%20clean%20dark%20background%2C%20suspenseful%20mood&width=800&height=600&seq=article-casting-006&orientation=landscape',
    imageAlt: '影视圈选角潜规则',
    date: '2026-07-01',
    heat: '73.4w',
    tags: ['娱乐圈', '潜规则', '选角', '女演员'],
    isHot: false,
    isExclusive: false,
    author: '深喉线人',
    authorTitle: '资深娱记',
  },
  {
    id: '7',
    slug: 'duan-shipin-pingtai-neimu-007',
    title: '某短视频平台算法黑幕：花钱买流量，不交保护费就限流降权',
    excerpt: '多位短视频创作者向911爆料网反映，某知名短视频平台存在付费买流量的灰色产业链，不向平台交纳"推广费"的创作者会被系统性限流。',
    content: `<p>短视频平台的"算法推荐"究竟是技术还是生意？近日，多位创作者向911爆料网反映了他们的遭遇。</p>
    <p>一位拥有50万粉丝的创作者表示，自己的账号在没有收到任何违规通知的情况下，流量突然下降了80%。"联系了平台的运营人员，对方暗示我需要'合作推广'。其实就是花钱买流量。"</p>
    <p>据了解，这种"合作推广"的方式多种多样，包括付费投流、参加平台活动、与平台签约独家等。如果不参与，账号就会被平台的算法"边缘化"处理。</p>
    <p>另一位创作者提供了更详细的内幕："平台有一个隐形的'白名单'制度，交了钱的账号会被优先推荐。没有交钱的，内容再优质也很难获得曝光。"</p>
    <p>对此，平台方面回应称不存在所谓的"保护费"制度，流量分配完全由算法根据内容质量决定。但众多创作者的亲身经历似乎与官方说法存在明显矛盾。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20data%20stream%20in%20dark%20tunnel%2C%20binary%20code%20flowing%20downward%2C%20red%20warning%20signals%20among%20green%20data%2C%20cyberpunk%20aesthetic%2C%20dark%20background%20with%20neon%20accents%2C%20algorithm%20manipulation%20concept%2C%20mysterious%20digital%20atmosphere%2C%20cinematic%20composition&width=800&height=600&seq=article-algorithm-007&orientation=landscape',
    imageAlt: '短视频平台算法黑幕',
    date: '2026-06-30',
    heat: '92.1w',
    tags: ['短视频', '算法', '限流', '付费推广'],
    isHot: false,
    isExclusive: true,
    author: '数字观察者',
    authorTitle: '科技记者',
  },
  {
    id: '8',
    slug: 'yi-ren-shuiwu-taoshu-008',
    title: '某一线艺人被曝通过工作室拆分收入逃税，金额或达数千万',
    excerpt: '税务圈知情人士向911爆料网透露，某一线艺人通过注册多家工作室拆分个人收入的方式规避高额个税，涉及金额可能高达数千万元。',
    content: `<p>自某知名女星因税务问题被封杀后，娱乐圈的税务问题似乎并未得到根本性解决。近日有税务圈人士向911爆料网透露，某当红一线艺人存在严重的税务问题。</p>
    <p>据爆料人介绍，该艺人通过注册多家个人工作室的方式，将原本属于个人劳务报酬的高额收入，拆分为多家工作室的经营收入。通过这种方式，原本应按45%最高税率缴纳个税的收入，被转换为按核定征收方式纳税，实际税负大幅降低。</p>
    <p>"粗略估算，该艺人通过这种方式可能少缴纳了数千万元的税款。"爆料人表示。</p>
    <p>值得注意的是，这种操作方式在法律上存在较大的灰色地带。如果被认定为"以合法形式掩盖非法目的"，则可能面临补缴税款、滞纳金甚至刑事处罚的风险。</p>
    <p>目前，相关税务部门尚未对此事作出回应。但业内人士表示，在金税四期全面上线的背景下，此类操作被发现的风险正在大幅增加。</p>`,
    category: '明星聊天记录',
    categorySlug: 'mingxing-liaotian',
    image: 'https://readdy.ai/api/search-image?query=Dark%20office%20desk%20with%20financial%20documents%20and%20calculator%2C%20dramatic%20side%20lighting%2C%20red%20stamp%20marks%20on%20papers%2C%20mysterious%20corporate%20atmosphere%2C%20cinematic%20noir%20style%2C%20deep%20shadows%2C%20tax%20evasion%20concept%2C%20clean%20dark%20background%2C%20suspenseful%20mood&width=800&height=600&seq=article-tax-008&orientation=landscape',
    imageAlt: '艺人税务问题',
    date: '2026-06-29',
    heat: '145.6w',
    tags: ['艺人', '逃税', '工作室', '金税四期'],
    isHot: false,
    isExclusive: false,
    author: '账本侦探',
    authorTitle: '财经调查员',
  },
  {
    id: '9',
    slug: 'wangluo-qun-zu-hei-chan-009',
    title: '起底"网络水军"黑色产业链：一条差评500元，抹黑竞品明码标价',
    excerpt: '911爆料网深入调查网络水军黑色产业链，发现从刷好评、恶意差评到舆论操控已形成完整产业链，价格透明、服务专业。',
    content: `<p>近日，911爆料网记者通过暗访方式，深入调查了隐藏在网络深处的"水军"黑色产业链，揭开了一个触目惊心的地下世界。</p>
    <p>记者在多个社交平台上搜索相关关键词后，很容易就找到了多个水军招募群。在这些群里，"任务发布者"每天都在发布大量的刷单、刷评、控评任务。</p>
    <p>价格体系非常"成熟"：某平台一条好评3-5元，恶意差评则高达50-500元不等，具体取决于账号等级和权重。如果是针对竞品的"套餐式抹黑服务"，价格从几千到几万不等。</p>
    <p>一位水军头目向记者炫耀："我们手里有上万个真实账号，可以做到完全模拟真实用户行为，平台根本查不出来。之前帮某品牌搞垮了一个竞品的新品发布，客户非常满意。"</p>
    <p>法律专家指出，此类行为已涉嫌违反《反不正当竞争法》和《网络信息内容生态治理规定》等多部法律法规，情节严重的可能构成刑事犯罪。但由于取证困难、跨地域等因素，实际打击效果有限。</p>`,
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    image: 'https://readdy.ai/api/search-image?query=Dark%20computer%20room%20with%20multiple%20screens%20displaying%20social%20media%20feeds%2C%20hacker%20cave%20atmosphere%2C%20red%20LED%20lighting%2C%20anonymous%20figure%20typing%2C%20cyber%20crime%20theme%2C%20mysterious%20digital%20underground%2C%20cinematic%20noir%20style%2C%20deep%20shadows%2C%20clean%20dark%20background&width=800&height=600&seq=article-waterarmy-009&orientation=landscape',
    imageAlt: '网络水军黑色产业链',
    date: '2026-06-28',
    heat: '110.3w',
    tags: ['水军', '黑色产业链', '刷单', '差评'],
    isHot: false,
    isExclusive: false,
    author: '暗网观察员',
    authorTitle: '调查记者',
  },
  {
    id: '10',
    slug: 'zhenren-xiu-neimu-baoliao-010',
    title: '某热门综艺被曝有剧本，选手淘汰顺序早已内定',
    excerpt: '一位曾参与某热门综艺制作的前工作人员向911爆料网透露，该节目的选手淘汰顺序、CP配对等环节均有剧本安排，真实程度不足三成。',
    content: `<p>真人秀到底有多"真"？近日，一位曾参与某热门综艺节目制作的前工作人员向911爆料网揭开了行业内的公开秘密。</p>
    <p>"基本上所有的淘汰顺序都是提前定好的。导演组会根据选手的商业价值、话题度、背后的经纪公司等因素来决定谁走谁留。"该前工作人员坦言。</p>
    <p>更令人咋舌的是，节目中那些让观众磕到上头的CP也大多是"剧本安排"。"导演组会故意把两个人安排在一起，设计一些互动环节，后期再通过剪辑强化CP感。实际上他们私下可能根本不熟。"</p>
    <p>该工作人员还爆料，选手们在节目中说的很多"金句"其实都是编剧提前写好的。"选手拿到台本后会先练习几遍，确保说出来够自然。有些选手演技好的，观众根本看不出来。"</p>
    <p>对于这一爆料，节目组回应称"所有真人秀节目都会有一定程度的设计和引导，这是为了给观众呈现更好的内容"，但否认存在"完全剧本化"的情况。</p>`,
    category: '博主私下爆料',
    categorySlug: 'bozhu-baoliao',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20TV%20show%20production%2C%20dark%20studio%20with%20cameras%20and%20lighting%20equipment%2C%20empty%20stage%20set%2C%20script%20papers%20on%20floor%2C%20dramatic%20backlighting%2C%20cinematic%20atmosphere%2C%20fake%20reality%20concept%2C%20red%20accent%20lighting%2C%20clean%20dark%20background&width=800&height=600&seq=article-realityshow-010&orientation=landscape',
    imageAlt: '综艺节目剧本内幕',
    date: '2026-06-27',
    heat: '85.9w',
    tags: ['综艺', '剧本', '选秀', '内定'],
    isHot: false,
    isExclusive: true,
    author: '台前幕后',
    authorTitle: '前电视从业者',
  },
];

export const getHotArticles = (): Article[] => articles.filter((a) => a.isHot);
export const getArticlesByCategory = (slug: string): Article[] => articles.filter((a) => a.categorySlug === slug);
export const getArticleBySlug = (slug: string): Article | undefined => articles.find((a) => a.slug === slug);
export const getRelatedArticles = (article: Article, count: number = 3): Article[] => {
  return articles.filter((a) => a.id !== article.id && a.categorySlug === article.categorySlug).slice(0, count);
};